/**
 * Punch Log Mock Data — June 2026
 * Generated programmatically. Shape matches the attendance-service punch-logs endpoint exactly.
 *
 * Roster:  15 active employees, company_id: 'comp-001'
 * Period:  June 1–30, 2026 (Mon–Fri, 22 working days)
 * Devices: device-001 Main Entrance | device-002 Engineering Floor | device-003 Cafeteria
 *
 * Punch patterns:
 *   Engineering employees (emp-001, emp-002, emp-006, emp-011, emp-015): 4 punches/day
 *     - Morning IN  → device-002 (Engineering Floor)
 *     - Lunch  OUT  → device-003 (Cafeteria)  ~13:00
 *     - Lunch  IN   → device-003 (Cafeteria)  ~13:45
 *     - Final  OUT  → device-002 (Engineering Floor)
 *   All other employees: 2 punches/day
 *     - Morning IN  → device-001 (Main Entrance)
 *     - Final  OUT  → device-001 (Main Entrance)
 *
 *   OT employees (emp-001, emp-002, emp-004, emp-010, emp-015): OUT after 19:00
 *   Non-OT employees: OUT between 17:30 and 18:30
 *
 * Special cases:
 *   Absent days (no punches):
 *     emp-003: 2026-06-02, 2026-06-09
 *     emp-014: 2026-06-15, 2026-06-22
 *     emp-009: 2026-06-05
 *   Anomaly days (IN only, no OUT):
 *     emp-003: 2026-06-10
 *     emp-007: 2026-06-17
 *     emp-011: 2026-06-24
 *   Duplicate punches:
 *     emp-002 2026-06-01: extra IN at 09:04
 *     emp-004 2026-06-03: extra IN 1 min after normal IN
 *     emp-010 2026-06-08: extra IN after lunch return (~14:01)
 */

const EMPLOYEES = [
  { id: 'emp-001', employee_code: 'EMP-00001', employee_name: 'Priya Mehta',          department: 'Engineering',      designation: 'Senior Engineer',      ot: true,  engineering: true  },
  { id: 'emp-002', employee_code: 'EMP-00002', employee_name: 'Arjun Patel',          department: 'Engineering',      designation: 'Software Engineer',    ot: true,  engineering: true  },
  { id: 'emp-003', employee_code: 'EMP-00003', employee_name: 'Sneha Reddy',          department: 'Product & Design', designation: 'Product Manager',      ot: false, engineering: false },
  { id: 'emp-004', employee_code: 'EMP-00004', employee_name: 'Rahul Gupta',          department: 'Sales',            designation: 'Sales Manager',        ot: true,  engineering: false },
  { id: 'emp-005', employee_code: 'EMP-00005', employee_name: 'Ananya Singh',         department: 'Human Resources',  designation: 'HR Executive',         ot: false, engineering: false },
  { id: 'emp-006', employee_code: 'EMP-00006', employee_name: 'Vikram Nair',          department: 'Engineering',      designation: 'DevOps Engineer',      ot: false, engineering: true  },
  { id: 'emp-007', employee_code: 'EMP-00007', employee_name: 'Kavya Joshi',          department: 'Product & Design', designation: 'UI/UX Designer',       ot: false, engineering: false },
  { id: 'emp-008', employee_code: 'EMP-00008', employee_name: 'Suresh Kumar',         department: 'Finance',          designation: 'Finance Analyst',      ot: false, engineering: false },
  { id: 'emp-009', employee_code: 'EMP-00009', employee_name: 'Meera Pillai',         department: 'Sales',            designation: 'Sales Executive',      ot: false, engineering: false },
  { id: 'emp-010', employee_code: 'EMP-00010', employee_name: 'Amit Verma',           department: 'Operations',       designation: 'VP Operations',        ot: true,  engineering: false },
  { id: 'emp-011', employee_code: 'EMP-00011', employee_name: 'Deepak Sharma',        department: 'Engineering',      designation: 'QA Engineer',          ot: false, engineering: true  },
  { id: 'emp-012', employee_code: 'EMP-00012', employee_name: 'Pooja Iyer',           department: 'Human Resources',  designation: 'HR Manager',           ot: false, engineering: false },
  { id: 'emp-013', employee_code: 'EMP-00013', employee_name: 'Ravi Shankar',         department: 'Operations',       designation: 'Office Manager',       ot: false, engineering: false },
  { id: 'emp-014', employee_code: 'EMP-00014', employee_name: 'Nisha Agarwal',        department: 'Sales',            designation: 'Business Dev Manager', ot: false, engineering: false },
  { id: 'emp-015', employee_code: 'EMP-00015', employee_name: 'Karthik Subramanian', department: 'Engineering',      designation: 'Tech Lead',            ot: true,  engineering: true  },
];

// Absent days — no punches generated. Key format: 'emp-id|YYYY-MM-DD'
const ABSENT_DAYS = new Set([
  'emp-003|2026-06-02',
  'emp-003|2026-06-09',
  'emp-014|2026-06-15',
  'emp-014|2026-06-22',
  'emp-009|2026-06-05',
]);

// Anomaly days — only IN punch produced, no OUT. Key format: 'emp-id|YYYY-MM-DD'
const ANOMALY_DAYS = new Set([
  'emp-003|2026-06-10',
  'emp-007|2026-06-17',
  'emp-011|2026-06-24',
]);

// Engineering employee order for computing their individual IN times
const ENG_ORDER = ['emp-001', 'emp-002', 'emp-006', 'emp-011', 'emp-015'];

/** Returns all weekdays (Mon–Fri) in June 2026 as 'YYYY-MM-DD' strings. */
function getJune2026Weekdays() {
  const dates = [];
  for (let d = 1; d <= 30; d++) {
    const date = new Date(Date.UTC(2026, 5, d));
    const dow = date.getUTCDay(); // 0=Sun, 6=Sat
    if (dow !== 0 && dow !== 6) {
      dates.push(`2026-06-${String(d).padStart(2, '0')}`);
    }
  }
  return dates; // 22 days
}

/** Convert total minutes since midnight to 'HH:MM'. */
function minsToHHMM(totalMins) {
  const h = Math.floor(totalMins / 60) % 24;
  const m = totalMins % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

/** Build ISO 8601 IST timestamp. hhmm is 'HH:MM'. */
function toIST(dateStr, hhmm) {
  return `${dateStr}T${hhmm}:00+05:30`;
}

/**
 * Base IN time in minutes since midnight, stable per employee.
 * Engineering: 08:30 + engIdx*9 min  → 08:30 … 09:06
 * Others:      08:45 + ei*6 min       → 08:45 … 09:09 (at ei=14: 09:09)
 */
function baseInMins(ei, emp) {
  if (emp.engineering) {
    const engIdx = ENG_ORDER.indexOf(emp.id);
    return 8 * 60 + 30 + engIdx * 9; // 510 | 519 | 528 | 537 | 546
  }
  return 8 * 60 + 45 + ei * 6;
}

/** Zero-pad a number to the given width. */
function pad(n, width = 5) {
  return String(n).padStart(width, '0');
}

function generatePunchLogs() {
  const weekdays = getJune2026Weekdays();
  const logs = [];
  let seq = 1;

  for (let ei = 0; ei < EMPLOYEES.length; ei++) {
    const emp = EMPLOYEES[ei];
    const inBase = baseInMins(ei, emp);

    for (const date of weekdays) {
      const key = `${emp.id}|${date}`;

      // Skip absent days entirely — no punch records
      if (ABSENT_DAYS.has(key)) continue;

      const isAnomaly = ANOMALY_DAYS.has(key);

      if (emp.engineering) {
        // ── 4-punch pattern (Engineering employees) ──────────────────────────

        // Morning IN at Engineering Floor
        logs.push({
          id: `punch-${pad(seq++)}`,
          employee_id: emp.id,
          employee_code: emp.employee_code,
          employee_name: emp.employee_name,
          department: emp.department,
          designation: emp.designation,
          device_id: 'device-002',
          device_name: 'Engineering Floor',
          punch_type: 'IN',
          punch_time: toIST(date, minsToHHMM(inBase)),
          date,
          source: 'BIOMETRIC',
          status: 'PROCESSED',
          company_id: 'comp-001',
        });

        if (!isAnomaly) {
          // Lunch OUT at Cafeteria: 13:00 + ei*2 min
          const lunchOutMins = 13 * 60 + ei * 2;
          logs.push({
            id: `punch-${pad(seq++)}`,
            employee_id: emp.id,
            employee_code: emp.employee_code,
            employee_name: emp.employee_name,
            department: emp.department,
            designation: emp.designation,
            device_id: 'device-003',
            device_name: 'Cafeteria',
            punch_type: 'OUT',
            punch_time: toIST(date, minsToHHMM(lunchOutMins)),
            date,
            source: 'BIOMETRIC',
            status: 'PROCESSED',
            company_id: 'comp-001',
          });

          // Lunch IN at Cafeteria: 13:45 + ei*2 min
          const lunchInMins = 13 * 60 + 45 + ei * 2;
          logs.push({
            id: `punch-${pad(seq++)}`,
            employee_id: emp.id,
            employee_code: emp.employee_code,
            employee_name: emp.employee_name,
            department: emp.department,
            designation: emp.designation,
            device_id: 'device-003',
            device_name: 'Cafeteria',
            punch_type: 'IN',
            punch_time: toIST(date, minsToHHMM(lunchInMins)),
            date,
            source: 'BIOMETRIC',
            status: 'PROCESSED',
            company_id: 'comp-001',
          });

          // Final OUT at Engineering Floor
          // OT employees: 19:00 + ei min  | Non-OT: 17:30 + ei*4 min
          const outMins = emp.ot
            ? 19 * 60 + ei
            : 17 * 60 + 30 + ei * 4;
          logs.push({
            id: `punch-${pad(seq++)}`,
            employee_id: emp.id,
            employee_code: emp.employee_code,
            employee_name: emp.employee_name,
            department: emp.department,
            designation: emp.designation,
            device_id: 'device-002',
            device_name: 'Engineering Floor',
            punch_type: 'OUT',
            punch_time: toIST(date, minsToHHMM(outMins)),
            date,
            source: 'BIOMETRIC',
            status: 'PROCESSED',
            company_id: 'comp-001',
          });
        }
      } else {
        // ── 2-punch pattern (all other employees) ─────────────────────────────

        // Morning IN at Main Entrance
        logs.push({
          id: `punch-${pad(seq++)}`,
          employee_id: emp.id,
          employee_code: emp.employee_code,
          employee_name: emp.employee_name,
          department: emp.department,
          designation: emp.designation,
          device_id: 'device-001',
          device_name: 'Main Entrance',
          punch_type: 'IN',
          punch_time: toIST(date, minsToHHMM(inBase)),
          date,
          source: 'BIOMETRIC',
          status: 'PROCESSED',
          company_id: 'comp-001',
        });

        if (!isAnomaly) {
          // Final OUT at Main Entrance
          const outMins = emp.ot
            ? 19 * 60 + ei
            : 17 * 60 + 30 + ei * 4;
          logs.push({
            id: `punch-${pad(seq++)}`,
            employee_id: emp.id,
            employee_code: emp.employee_code,
            employee_name: emp.employee_name,
            department: emp.department,
            designation: emp.designation,
            device_id: 'device-001',
            device_name: 'Main Entrance',
            punch_type: 'OUT',
            punch_time: toIST(date, minsToHHMM(outMins)),
            date,
            source: 'BIOMETRIC',
            status: 'PROCESSED',
            company_id: 'comp-001',
          });
        }
      }
    }
  }

  // ── Special case: duplicate punches ────────────────────────────────────────
  // Appended here; sort below places them in correct chronological position.

  // emp-002 on 2026-06-01: duplicate IN at 09:04 (normal IN is 08:39)
  logs.push({
    id: `punch-${pad(seq++)}`,
    employee_id: 'emp-002',
    employee_code: 'EMP-00002',
    employee_name: 'Arjun Patel',
    department: 'Engineering',
    designation: 'Software Engineer',
    device_id: 'device-002',
    device_name: 'Engineering Floor',
    punch_type: 'IN',
    punch_time: '2026-06-01T09:04:00+05:30',
    date: '2026-06-01',
    source: 'BIOMETRIC',
    status: 'PROCESSED',
    company_id: 'comp-001',
  });

  // emp-004 on 2026-06-03: duplicate IN 1 min after normal IN (normal IN is 09:03)
  logs.push({
    id: `punch-${pad(seq++)}`,
    employee_id: 'emp-004',
    employee_code: 'EMP-00004',
    employee_name: 'Rahul Gupta',
    department: 'Sales',
    designation: 'Sales Manager',
    device_id: 'device-001',
    device_name: 'Main Entrance',
    punch_type: 'IN',
    punch_time: '2026-06-03T09:04:00+05:30',
    date: '2026-06-03',
    source: 'BIOMETRIC',
    status: 'PROCESSED',
    company_id: 'comp-001',
  });

  // emp-010 on 2026-06-08: duplicate IN after lunch return (~14:01)
  logs.push({
    id: `punch-${pad(seq++)}`,
    employee_id: 'emp-010',
    employee_code: 'EMP-00010',
    employee_name: 'Amit Verma',
    department: 'Operations',
    designation: 'VP Operations',
    device_id: 'device-001',
    device_name: 'Main Entrance',
    punch_type: 'IN',
    punch_time: '2026-06-08T14:01:00+05:30',
    date: '2026-06-08',
    source: 'BIOMETRIC',
    status: 'PROCESSED',
    company_id: 'comp-001',
  });

  // Sort ascending by punch_time (ISO strings sort lexicographically)
  logs.sort((a, b) => a.punch_time.localeCompare(b.punch_time));

  return logs;
}

export const mockPunchLogs = generatePunchLogs();

export const mockPunchDevices = [
  { id: 'device-001', name: 'Main Entrance',     location: 'Ground Floor' },
  { id: 'device-002', name: 'Engineering Floor', location: '3rd Floor'    },
  { id: 'device-003', name: 'Cafeteria',         location: 'Ground Floor' },
];
